export default __webpack_public_path__ + "static/media/HCL.2d3baa84.png";